import styled from 'styled-components'
import OffIcon from '../../../static/images/styled_components/icon_trash_grey.svg'
import OverIcon from '../../../static/images/styled_components/icon_trash.svg'

const DeleteButton = styled.div`
  height: 33px;
  width: 33px;
  background: 50% 50% #fff no-repeat url(${OffIcon});
  background-size: 13px 17px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 33px;
  cursor: pointer;

  &:hover {
    background: 50% 50% #fff no-repeat url(${OverIcon});
  }
`

export const DeleteButtonNoBackground = styled.div`
  height: 33px;
  width: 33px;
  background: 50% 50% #fff no-repeat url(${OffIcon});
  border-radius: 33px;
  cursor: pointer;

  &:hover {
    background: 50% 50% #fff no-repeat url(${OverIcon});
  }
`

export default DeleteButton
